import {CommentManager} from '../CommentManager';
import {Headers} from '../types';
import {ApiClientFactory, ApiClientFactoryInterface} from './clients';

export class CommentManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/comment`, headers);
  }

  public createCommentManager(token: string): CommentManager {
    return new CommentManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}
